module.exports = __webpack_public_path__ + "static/media/partner-7.1dd0676d.png";